window.KKC_CONFIG = {
  "brand": "Stichting Keti Koti Connect",
  "email": "info@ketikoti-connect.nl",
  "programEmail": "programma@ketikoti-connect.nl",
  "partnerEmail": "sponsoring@ketikoti-connect.nl",
  "checkedAt": "2026-10-16",
  "events": {
    "keti-koti": {
      "title": "Keti Koti Festival Wijkpark",
      "dateLabel": "Donderdag 1 juli 2027",
      "dateShort": "1 juli 2027",
      "dateISO": "2027-07-01",
      "location": "Wijkpark Oude Westen, Rotterdam",
      "locationShort": "Wijkpark Oude Westen",
      "time": "12.00 - 22.00 uur",
      "admission": "Gratis toegang",
      "status": "Bezoekersregistratie",
      "ticketUrl": "https://atleta.cc/e/5MmLrXVWIjSO/tickets",
      "ticketLabel": "Gratis bezoekersregistratie",
      "ticketType": "registration"
    },
    "kabra-neti": {
      "title": "Kabra Neti",
      "dateLabel": "Dinsdag 30 juni 2026",
      "dateShort": "30 juni 2026",
      "dateISO": "2026-06-30",
      "location": "Zalencentrum Sunrise, Galvanistraat 150, Rotterdam",
      "locationShort": "Zalencentrum Sunrise",
      "time": "Inloop 17.00 uur; programma 18.00 - 00.30 uur",
      "admission": "Archief: voorverkoop EUR 25, aan de deur EUR 35",
      "status": "Terugblik 2026 - geen actuele kaartverkoop",
      "ticketUrl": "",
      "ticketLabel": "Bekijk de terugblik",
      "ticketType": "archive"
    }
  },
  "websiteUrl": "https://ketikoticonnect.nl",
  "sourceNote": "Samengevoegd uit de aangeleverde bestanden; dit is geen externe live-verificatie.",
  "stallEmail": "kramen@ketikoti-connect.nl",
  "paradeEmail": "bigispikri@ketikoti-connect.nl"
};
